import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import { Trans } from "react-i18next";
import { useRef } from "react";

export const CreatingCollectionFeatures = () => {
  const title = useRef(null);
  const item1 = useRef(null);
  const item2 = useRef(null);
  const item3 = useRef(null);
  const item4 = useRef(null);

  useAnimation([title, item1, item2, item3, item4]);

  return (
    <section className="relative z-10 h-full overflow-hidden bg-primary font-montserrat">
      <div className="relative mx-auto max-w-3xl px-6 pb-20 pt-14 md:px-12 lg:px-0">
        <Sprite
          name="zigzag-translucent"
          className="absolute -left-24 h-[225px] w-[450px] opacity-40 md:left-[-43rem] md:h-[373px] md:w-[746px]"
        />
        <p
          ref={title}
          data-animation="animate__animated animate__fadeInDown"
          className="z-10 mx-auto mb-12 text-center text-[22px] font-bold leading-[26px] text-white ltr:max-w-xs rtl:max-w-[300px] md:mb-20 md:text-[45px] md:leading-[54px] ltr:md:max-w-[650px] rtl:md:max-w-[500px]"
        >
          <Trans>After you are done creating your collection you can:</Trans>
        </p>
        <div className="z-10 grid gap-12 text-white md:grid-cols-3-inner-small md:grid-rows-3-inner-small md:gap-0">
          <div
            ref={item1}
            data-animation="animate__animated animate__fadeInLeft"
            className="order-1 flex flex-col items-center gap-6 text-center md:gap-10 rtl:md:order-3"
          >
            <Sprite name="star-icon" className="h-10 w-10 md:h-12 md:w-12" />
            <p className="max-w-[142px] text-sm font-bold leading-5 rtl:font-almarai md:max-w-[186px] md:text-lg md:leading-6">
              <Trans>Feature it on your cShop.</Trans>
            </p>
          </div>
          <div className="order-2 flex justify-center">
            <div className="h-px w-48 bg-white md:h-full md:w-px" />
          </div>
          <div
            ref={item2}
            data-animation="animate__animated animate__fadeInRight animate__delay-1s"
            className="order-3 flex flex-col items-center gap-6 text-center md:gap-10 rtl:md:order-1"
          >
            <Sprite
              name="whatsapp-icon"
              className="h-10 w-10 md:h-12 md:w-12"
            />
            <p className="max-w-[165px] text-sm font-bold leading-5 rtl:font-almarai md:max-w-[212px] md:text-lg md:leading-6">
              <Trans>Send it on WhatsApp to one or a group of people.</Trans>
            </p>
          </div>
          <div className="order-4 hidden items-center justify-center md:flex">
            <div className="h-px w-3/5 bg-white" />
          </div>
          <div className="order-5 flex justify-center">
            <div className="h-px w-48 bg-white md:hidden" />
          </div>
          <div className="order-6 hidden items-center justify-center md:flex">
            <div className="h-px w-3/5 bg-white" />
          </div>
          <div
            ref={item3}
            data-animation="animate__animated animate__fadeInLeft animate__delay-2s"
            className="order-7 flex flex-col items-center gap-6 text-center md:gap-10 rtl:md:order-9"
          >
            <Sprite name="share-icon" className="h-10 w-10 md:h-12 md:w-12" />
            <p className="max-w-[250px] text-sm font-bold leading-5 rtl:font-almarai md:max-w-xs md:text-lg md:leading-6">
              <Trans>
                Click on “More” and send it by email or any other social or
                messaging app like Instagram, Facebook, Snapchat etc.
              </Trans>
            </p>
          </div>
          <div className="order-8 flex justify-center">
            <div className="h-px w-48 bg-white md:h-full md:w-px" />
          </div>
          <div
            ref={item4}
            data-animation="animate__animated animate__fadeInRight animate__delay-3s"
            className="order-9 flex flex-col items-center gap-6 text-center md:gap-10 rtl:md:order-7"
          >
            <Sprite name="copy-icon" className="h-10 w-10 md:h-12 md:w-12" />
            <p className="max-w-[265px] text-sm font-bold leading-5 rtl:font-almarai md:max-w-[350px] md:text-lg md:leading-6">
              <Trans>
                Copy the link and paste it anywhere you like, your Instagram bio
                or add it to your linktree for example.
              </Trans>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
